import styled from '@emotion/styled';
import {
  Delete,
  HomeRepairServiceOutlined,
  MoveDownOutlined,
} from '@mui/icons-material';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import DeviceHubIcon from '@mui/icons-material/DeviceHub';
import InfoIcon from '@mui/icons-material/Info';
import { GridActionsCellItem } from '@mui/x-data-grid';

import TableActionButtons from '../../components/shared/TableActionButtons/TableActionButtons';

const useBranchListTableColumns = ({
  goToInfoPage,
  goToGraphPage,
  goToRootPage,
  deleteItem,
  editItem,
  changeOrigin,
  apiRef,
  permissions = {},
}) => {
  const {
    canDetail = false,
    canDelete = false,
    canReorder = false,
    canGoToRoot = false,
  } = permissions;

  const canViewActions = canDetail || canGoToRoot || canReorder || canDelete;

  const columnsData = [
    // {
    //   field: 'image',
    //   headerName: 'تصویر',
    //   flex: 0.3,
    //   minWidth: 120,
    //   resizable: true,
    //   editable: false,
    //   renderCell: params => {
    //     apiRef.current = params.api;
    //     return <ColImage src={params.row.imageURL} alt={params.row.title} />;
    //   },
    // },

    {
      field: 'title',
      headerName: 'عنوان',
      flex: 1,
      minWidth: 120,
      resizable: true,
      editable: false,
    },

    ...(canViewActions
      ? [
          {
            field: 'actions',
            headerName: 'عملیات',
            type: 'actions',
            flex: 0.2,
            minWidth: 120,
            getActions: params => {
              const buttons = [
                canDetail
                  ? {
                      label: 'جزئیات',
                      Icon: InfoIcon,
                      onClick: goToInfoPage(params.row),
                      color: 'warning',
                    }
                  : null,
                canGoToRoot
                  ? {
                      label: 'ریشه',
                      Icon: DeviceHubIcon,
                      onClick: goToRootPage(params.row),
                      color: 'primary',
                    }
                  : null,
              ].filter(Boolean);

              return [
                buttons.length ? (
                  <TableActionButtons key={10} buttons={buttons} />
                ) : null,
                canReorder ? (
                  <GridActionsCellItem
                    key={3}
                    icon={<MoveDownOutlined />}
                    label="جابجایی"
                    onClick={changeOrigin(params.row)}
                    showInMenu
                  />
                ) : null,
                canDelete ? (
                  <GridActionsCellItem
                    key={4}
                    icon={<Delete />}
                    label="حذف"
                    onClick={deleteItem(params.row)}
                    showInMenu
                  />
                ) : null,
              ].filter(Boolean);
            },
          },
        ]
      : []),
  ];

  return [columnsData];
};

export default useBranchListTableColumns;

const ColImage = styled.img`
  object-fit: fill;
  max-width: 60px;
  max-height: 90%;
`;
